enum ElementType {
  BULLETED_LIST = "bulleted-list",
  DYNAMIC_VARIABLE = "dynamic-variable",
  IMAGE = "image",
  INDENT = "indent",
  LINK = "link",
  LIST_ITEM = "list-item",
  MENTION = "mention",
  NUMBERED_LIST = "numbered-list",
  PARAGRAPH = "paragraph",
  RESOURCE_LINK = "resource-link",
}

export default ElementType;
